import { ApiException } from '@/utils/errorHandler';

const VIA_CEP_BASE = 'https://viacep.com.br/ws';

export interface CepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
  erro?: boolean;
}

export async function buscarCep(digits: string): Promise<CepResponse> {
  const res = await fetch(`${VIA_CEP_BASE}/${digits}/json/`);

  if (!res.ok) {
    throw new ApiException(
      'Erro ao consultar o CEP. Tente novamente mais tarde.',
      res.status,
      'ViaCEP_Error',
      `/ws/${digits}/json/`,
      undefined,
      undefined
    );
  }

  const data = (await res.json()) as CepResponse;

  if (data.erro) {
    throw new ApiException(
      'CEP não encontrado.',
      404,
      'ViaCEP_NotFound',
      `/ws/${digits}/json/`,
      undefined,
      undefined
    );
  }

  return data;
}